import request from '@/util/request';

// 获取字典
export const getDictApi = (params, options) =>
  request.get('/api/blade-system/dict/dictionary', Object.assign({}, options, { params }));

// 获取项目列表
export const getProjectListApi = (params, options) =>
  request.get('/api/v4ward/project/getProjectList', Object.assign({}, options, { params }));

// 获取仓库列表
export const getWarehouseListApi = (params, options) =>
  request.get('/api/v4ward/warehouse/getWarehouseList', Object.assign({}, options, { params }));

// 获取所有的（无权限控制）仓库列表
export const getAllWarehouseListApi = (params, options) =>
  request.get('/api/v4ward/warehouse/getAllWarehouseList', Object.assign({}, options, { params }));